<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="tabTitle"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [ngClass]="{'flex-content': windowService.isDesktopRes && selectedTab === 'transactions'}">
    @if (!loaded) {
      <div style="display: flex; gap: 8px; margin-bottom: 15px;">
        @for (i of [1,2,3,4,5]; track i) {
          <ion-skeleton-text animated="true" style="height: 36px; width: 100px; border-radius: 16px" />
        }
      </div>
      <div style="width: 100%; margin-bottom: 12px;">
        <ion-skeleton-text animated="true" style="height: 40px; border-radius: 6px" />
      </div>
      @for (i of [1,2,3,4,5]; track i) {
        <div style="width: 100%; margin-bottom: 6px;">
          <ion-skeleton-text animated="true" style="height: 44px; border-radius: 4px" />
        </div>
      }
    }

    @if (loaded) {
      @if (selectedTab === 'bills') {
        <bills-content />
      }

      <!-- @if (selectedTab === 'receivables') {
        <receivables-content />
      } -->

      @if (selectedTab === 'deposits') {
        <deposits-content />
      }

      @if (selectedTab === 'rent-collection') {
        <payments-content />
      }

      @if (selectedTab === 'leases') {
        <leases-content />
      }

      <!-- @if (selectedTab === 'income') {
        <payments-config-content />
      } -->

      @if (selectedTab === 'transactions') {
        <transactions-content />
      }

      @if (selectedTab === 'taxes') {
        <taxes-content />
      }

      @if (selectedTab === 'monthly') {
        <monthly-content />
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />
